import { TextLink, Typography } from 'components';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import styles from './YourCategoryScores.module.css';
import YourCategoryScoresCards from './YourCategoryScoresCards';

export default function YourCategoryScores() {
  const currentKitId = useGetKitIdParam();

  const metricsUrl = `/results/${currentKitId}/metrics/all-metrics`;

  return (
    <div className={styles.container}>
      <div className={styles.titleAndLink}>
        <Typography variant='heading-m'>Category scores</Typography>
        <TextLink
          label='View all metrics'
          to={metricsUrl}
          size='body-s'
          iconNameRight='chevronForward'
          className='hide-on-mobile'
        />
        <TextLink
          label='All metrics'
          to={metricsUrl}
          size='body-s'
          className='hide-on-desktop'
        />
      </div>
      <YourCategoryScoresCards />
    </div>
  );
}
